// We don't have a table and mobile versions. Therefore, set min-width
// to guarantee the best view.
export const MIN_LAYOUT_WIDTH = 780;
